module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "property-pane"
  }, [(_vm.property.label) ? _c('h3', {
    staticClass: "property-title"
  }, [_vm._v(_vm._s(_vm.property.label))]) : _vm._e(), (_vm.property.attributes) ? _c('div', {
    staticClass: "attributes-wrapper"
  }, _vm._l((_vm.property.attributes), function(attribute, attrIndex) {
    return (attribute.value) ? _c('div', {
      key: attrIndex,
      staticClass: "attribute-pane"
    }, [_c('div', {
      staticClass: "attribute-label"
    }, [_vm._v(_vm._s(attribute.label))]), (_vm.isUrl(attribute.value)) ? _c('div', {
      staticClass: "attribute-value"
    }, [_c('a', {
      attrs: {
        "href": attribute.value,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attribute.value))])]) : _c('div', {
      staticClass: "attribute-value"
    }, [_vm._v(_vm._s(attribute.value))])]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54b37392","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/person/PropertyPane.vue
// module id = 1753
// module chunks = 1